import { render, staticRenderFns } from "./Facets.vue?vue&type=template&id=24c4e589"
import script from "./Facets.vue?vue&type=script&setup=true&lang=js"
export * from "./Facets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports